(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function money(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    function grupos(n, dec, miles, decimal) {
      var partes = (cents / 100).toFixed(dec).split('.');
      partes[0] = partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles);
      return partes.join(decimal);
    }
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, tipo) {
      switch (tipo) {
        case 'amount_no_decimals': return grupos(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return grupos(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return grupos(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return grupos(cents, 2, "'", '.');
        default: return grupos(cents, 2, ',', '.');
      }
    });
  }

  function initProducto(root) {
    if (root.getAttribute('data-mt-listo')) return;
    root.setAttribute('data-mt-listo', '1');
    var dataEl = root.querySelector('[data-mt-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = root.querySelector('form[data-mt-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var boton = root.querySelector('[data-mt-boton]');
    var precio = root.querySelector('[data-mt-precio]');
    var antes = root.querySelector('[data-mt-antes]');
    var ahorro = root.querySelector('[data-mt-ahorro]');
    var barraPrecio = document.querySelector('[data-mt-barra-precio]');
    var barraBoton = document.querySelector('[data-mt-barra-boton]');
    var textoComprar = boton ? boton.getAttribute('data-texto-comprar') : '';
    var textoAgotado = boton ? boton.getAttribute('data-texto-agotado') : '';
    var formato = root.getAttribute('data-money-format');

    function seleccion() {
      var vals = [];
      root.querySelectorAll('.mt-opcion').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        vals.push(checked ? checked.value : null);
      });
      return vals;
    }

    function actualizar() {
      if (!variants.length) return;
      var vals = seleccion();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === vals[i]; });
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (precio) precio.textContent = money(v.price, formato);
      if (barraPrecio) barraPrecio.textContent = money(v.price, formato);
      var hayOferta = v.compare_at_price && v.compare_at_price > v.price;
      if (antes) {
        if (hayOferta) { antes.textContent = money(v.compare_at_price, formato); antes.hidden = false; }
        else { antes.hidden = true; }
      }
      if (ahorro) {
        if (hayOferta) {
          ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
          ahorro.hidden = false;
        } else { ahorro.hidden = true; }
      }
      [boton, barraBoton].forEach(function (b) {
        if (!b) return;
        b.disabled = !v.available;
        var label = b.querySelector('[data-mt-boton-label]') || b;
        label.textContent = v.available ? textoComprar : textoAgotado;
      });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('.mt-opcion input').forEach(function (i) {
      i.addEventListener('change', actualizar);
    });

    var principal = root.querySelector('[data-mt-principal] img');
    var thumbs = root.querySelectorAll('[data-mt-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!principal) return;
        principal.src = t.getAttribute('data-src');
        principal.srcset = t.getAttribute('data-srcset') || '';
        principal.alt = t.getAttribute('data-alt') || '';
        thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    var barra = document.querySelector('[data-mt-barra]');
    if (barra && boton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          barra.classList.toggle('mt-barra--visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }).observe(boton);
    }
    if (barraBoton && boton) {
      barraBoton.addEventListener('click', function () {
        if (form) { if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); } }
      });
    }
  }

  function init() {
    initReveal();
    document.querySelectorAll('[data-mt-producto]').forEach(initProducto);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
